import { Box } from "@mui/material";
import {
  ProgressStepper,
  Shadows,
} from "@axismaxlife/unified-ui-components-library";
import { useLocation } from "react-router-dom";
import {
  JourneyStepsArray,
  getActiveStepNumber,
} from "../constants/JourneyStepsArray";
import { String } from "../constants/Strings";
import { fonts } from "../style/fonts/fonts";
import { colors } from "../style/color/colors";

const getStepState = (stepNumber, activeStepNumber) => {
  if (stepNumber < activeStepNumber) return "completed";
  if (stepNumber === activeStepNumber) return "active";
  return "inactive";
};

export const JourneyProgressStepper = () => {
  const location = useLocation();
  const activeStepNumber = getActiveStepNumber(location.pathname);
  if (!activeStepNumber) {
    return null;
  }

  const steps = JourneyStepsArray.map((step) => ({
    id: step.id,
    stepNumber: step.stepNumber,
    label: step.label,
    state: getStepState(step.stepNumber, activeStepNumber),
  }));

  return (
    <Box
      sx={{
        width: "100vw",
        position: "relative",
        left: "50%",
        right: "50%",
        marginLeft: "-50vw",
        marginRight: "-50vw",
        boxSizing: "border-box",
        px: "16px",
        backgroundColor: colors.cloudGray,
        boxShadow: Shadows.Flash,
        "& .step-label": {
          fontFamily: `${fonts.notoSans} !important`,
          fontSize: "10px !important",
          fontWeight: "600 !important",
          color: `${colors.NeutralDark600} !important`,
        },
        "& .step-label--active": {
          color: `${colors.PrimaryWoodSmoke} !important`,
        },
      }}
    >
      <ProgressStepper
        steps={steps}
        direction="horizontal"
        width="100%"
        ariaLabel={String.journeySteps.ariaLabel}
        size="small"
      />
    </Box>
  );
};
